import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import * as globals from '../globals';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

@Injectable()
export class materialAdminService {

    private materialUrl = globals.APIURL + '/admin/material';
    private CategoryUrl = this.materialUrl + '/materialcategory';

    constructor(private http: Http, public authHttp: AuthHttp) {

    }

    /**
     * fetch all Material in MR2 Database
     * @return JSON response body / Error
     */
    getMaterials(): Observable<string> {
        let headers = new Headers({'Content-Type': 'application/json'});
        let options = new RequestOptions({ body: '', headers: headers });
        return this.authHttp.get(this.materialUrl, options)
        .map(this.extractData)
        .catch(this.handleError);
    }

    /**
  * Add new Category in MR2 Database
  * @param string category name
  * @return JSON response body / Error
  */
    addNewCategory(category_name: any): Observable<string> {
        console.log('get users service called');

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let body = JSON.stringify({
            name: category_name
        });

        let options = new RequestOptions({ headers: headers });

        console.log('Projects: OPTIONS =>', options);
        console.log('URL:', this.CategoryUrl);

        return this.authHttp.post(this.CategoryUrl, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

       /**
  * Add new material in MR2 Database
  * @param string material name
  * @return JSON response body / Error
  */
    addNewMaterial(material_name: any, materialcategory_id: any, material_description: any, material_unit_id: any, material_density: any, material_price: any ): Observable<string> {
        console.log('get users service called');

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let body = JSON.stringify({
            name: material_name, materialcategory_id: materialcategory_id, description: material_description,
            materialunit_id: material_unit_id, density: material_density, price: material_price
        });

        let options = new RequestOptions({ headers: headers });

        console.log('Projects: OPTIONS =>', options);
        console.log('URL:', this.materialUrl);

        return this.authHttp.post(this.materialUrl, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    /**
  * edit Category in MR2 Database
  * @param string category name
  * @return JSON response body / Error
  */
    editCategory(category: any, updatedName: string): Observable<string> {
        console.log('get users service called');

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let body = JSON.stringify({
            id: category.id, name: updatedName,
        });

        let options = new RequestOptions({ headers: headers });
        console.log('Projects: OPTIONS =>', options);
        console.log('URL:', this.CategoryUrl + '/' + category.id);

        return this.authHttp.put(this.CategoryUrl + '/' + category.id, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    /**
  * remove Category in MR2 Database
  * @param string category name
  * @return JSON response body / Error
  */
    removeCategory(category: any): Observable<string> {
        console.log('get users service called');

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let body = JSON.stringify({
            name: category.name
        });

        let options = new RequestOptions({ headers: headers });
        console.log('Projects: OPTIONS =>', options);
        console.log('URL:', this.CategoryUrl + '/' + category.id);

        return this.authHttp.delete(this.CategoryUrl + '/' + category.id ,  options)
            .map(this.extractData)
            .catch(this.handleError);
    }

        /**
  * remove Category in MR2 Database
  * @param string category name
  * @return JSON response body / Error
  */
    removeMaterial(material: any): Observable<string> {
        console.log('get users service called');

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let body = JSON.stringify({
            name: material.name
        });

        let options = new RequestOptions({ headers: headers });
        console.log('Projects: OPTIONS =>', options);
        console.log('URL:', this.materialUrl + '/' + material.id);

        return this.authHttp.delete(this.materialUrl + '/' + material.id ,  options)
            .map(this.extractData)
            .catch(this.handleError);
    }

     /**
    * Add new material in MR2 Database
    * @param string resource name
    * @return JSON response body / Error
    */
    updateMaterial(material: any): Observable<string> {
        console.log('get users service called');

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let body = JSON.stringify({
            id: material.id, name: material.name, materialcategory_id: material.materialcategory_id, description: material.description,
            density: material.density, materialunit_id: material.materialunit_id, price: material.price
        });

        let options = new RequestOptions({ headers: headers });

        console.log('Projects: OPTIONS =>', options);
        console.log('URL:', this.materialUrl);

        return this.authHttp.put(this.materialUrl + '/' + material.id, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    updateResourcescategories(oldResourceID: any, newResourceID: any): Observable<string> {

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let body = JSON.stringify({
        category:
           {
               old : oldResourceID,
               new : newResourceID
           }
        });

        let options = new RequestOptions({ headers: headers });
        // console.log('Projects: OPTIONS =>', options);
        console.log('URL:', this.materialUrl);

        return this.authHttp.put(this.materialUrl , body,  options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        console.log('BODY:', body);
        return body || {};
    }

    handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/materialadmin/materialadmin.service.ts